import { useEffect } from 'react';
import { checkAndUpdateMetrics } from '@/services/categoryMetricsApiService';

/**
 * Kategori metriklerini periyodik olarak günceller
 * Uygulama başlangıcında bir kez çalışır
 */
export function useCategoryMetricsUpdater(enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return;

    // Sayfa yüklendiğinde kontrol et
    checkAndUpdateMetrics();
  }, [enabled]);
}
